var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2121:11330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.021 6.10601L9.793 1.87901C9.51528 1.59935 9.18478 1.37764 8.82068 1.22674C8.45658 1.07585 8.06613 0.998781 7.672 1.00001H1C0.734784 1.00001 0.48043 1.10537 0.292893 1.29291C0.105357 1.48044 0 1.7348 0 2.00001C0 2.26523 0.105357 2.51959 0.292893 2.70712C0.48043 2.89466 0.734784 3.00001 1 3.00001H7.672C7.93706 3.00073 8.19114 3.10602 8.379 3.29301L11.086 6.00001H5C3.67441 6.0016 2.40356 6.5289 1.46622 7.46623C0.528882 8.40357 0.00158786 9.67442 0 11L0 19C0.00158786 20.3256 0.528882 21.5965 1.46622 22.5338C2.40356 23.4711 3.67441 23.9984 5 24H13C14.3256 23.9984 15.5964 23.4711 16.5338 22.5338C17.4711 21.5965 17.9984 20.3256 18 19V11C17.9984 9.85172 17.6022 8.73887 16.8778 7.8479C16.1534 6.95692 15.1448 6.34195 14.021 6.10601Z",
    fill: "#D4C5D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8998 8.95484C22.5687 8.78705 22.1973 8.71536 21.8275 8.74788C21.4578 8.7804 21.1045 8.91583 20.8078 9.13884L20.0078 9.73884V20.2608L20.8078 20.8608C21.105 21.0837 21.4583 21.2194 21.8282 21.2528C22.1981 21.2861 22.57 21.2158 22.9022 21.0497C23.2345 20.8836 23.5138 20.6283 23.7091 20.3123C23.9044 19.9963 24.0078 19.6323 24.0078 19.2608V10.7428C24.0088 10.371 23.9055 10.0064 23.7097 9.69029C23.5138 9.37423 23.2332 9.11943 22.8998 8.95484Z",
    fill: "#D4C5D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2121:11330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.cbb3e98804b8205c11c272a67ffd608a.svg";
export { ForwardRef as ReactComponent };